<template>
    <div>
        <!-- 移动网络开关 -->
      <el-row>
      <el-col :span="24">
        <span class="font-title"
          >{{ $t("message.systemMsg.MobileNetworkSettings") }}
        </span>
      </el-col>
      <el-col :span="24">
        <span class="secondfont-title">{{ $t("message.systemMsg.MobileNetworkSwitch") }}</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.MobileNetworkSwitch") }}:</span>
        <el-select size="medium" v-model="m.mobileDataEnable">
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <!-- 移动网络管理 -->
     <el-row>
        <el-col :span="24">
        <span class="secondfont-title">{{ $t('messageAdd.mobile.001') }}</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.ApnName") }}:</span>
        <el-input size="medium" v-model="m.name"></el-input>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">APN:</span>
        <el-input size="medium" v-model="m.apn"></el-input>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.agent") }}:</span>
        <el-input size="medium" v-model="m.proxy"></el-input>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.port") }}:</span>
        <el-input size="medium" v-model="m.port"></el-input>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.userName") }}:</span>
        <el-input size="medium" v-model="m.userName"></el-input>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.password") }}:</span>
        <el-input size="medium" v-model="m.passWord"></el-input>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">MNC:</span>
        <el-input size="medium" v-model="m.mnc"></el-input>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">MCC:</span>
        <el-input size="medium" v-model="m.mcc"></el-input>
      </el-col>
     </el-row>
    </div>
</template>
<script>
export default {
  name: "mobileNet",
  props: {
    mobileNet: {
      type: Object
    }
  },
  data() {
    return {
   
      }
    },
    computed:{
      m(){
      return this.mobileNet
      }
    },
    watch:{
   // 监听 m 的变化，并通知父组件
   m: {
      handler(newVal) {
        this.$emit('update:mobileNet', newVal);
        this.$emit('update:config-mobileNet', newVal);
      },
      deep: true // 深度监听对象的变化
    }
  },
  methods: {},
  created(){
  }
}
</script>